import CreateWorkOrder from "../../views/WorkOrder/CreateWorkOrder";

const CreateWorkOrderPage = () => {
  return <CreateWorkOrder />;
};

export default CreateWorkOrderPage;
